export default {
    FindFavoritesClicked: {
        datapoint: {
            name: 'FindFavoritesClicked',
        },
    },
};
//# sourceMappingURL=datapoints.js.map